// extracted by mini-css-extract-plugin
export default {"current-platform-step-options":"FnIRQa","currentPlatformStepOptions":"FnIRQa"};